var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialIconInstagramRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "background",
    fill: "#ffffff",
    d: "M16,1A15,15,0,1,0,31,16,15,15,0,0,0,16,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon",
    fill: "#3d3d3d",
    d: "M21.23,7.47H10.77a3.3,3.3,0,0,0-3.3,3.3V21.23a3.3,3.3,0,0,0,3.3,3.3H21.23a3.3,3.3,0,0,0,3.3-3.3V10.77A3.3,3.3,0,0,0,21.23,7.47Zm0.95,2h0.38v2.89H19.67V9.44h2.52Zm-8.61,4.82A3,3,0,1,1,13,16,3,3,0,0,1,13.57,14.25Zm9.3,7a1.63,1.63,0,0,1-1.63,1.63H10.77a1.63,1.63,0,0,1-1.63-1.63v-7h2.55a4.67,4.67,0,1,0,8.64,0h2.55v7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "border",
    fill: "#3d3d3d",
    d: "M16,31.5C7.45,31.5,0.5,24.55,0.5,16S7.45,0.5,16,0.5S31.5,7.45,31.5,16S24.55,31.5,16,31.5z M16,1.5     C8,1.5,1.5,8,1.5,16S8,30.5,16,30.5S30.5,24,30.5,16S24,1.5,16,1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconInstagramRound);
export default __webpack_public_path__ + "static/media/social-icon-instagram-round.f4be383903c9e82d061516999e24ca03.svg";
export { ForwardRef as ReactComponent };